import { Component, OnInit, ViewChild } from "@angular/core";

import { Router } from "@angular/router";
import { MatInput } from "@angular/material";

import { VernostServiceService } from "../../../../services/vernost-service.service";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
import { CommonService } from "../../../../services/common.service";

@Component({
  selector: 'app-exception-report',
  templateUrl: './exception-report.component.html',
  styleUrls: ['./exception-report.component.css'],
  providers: [DatePipe]
})
export class ExceptionReportComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  Gdate: any;
  from: any;
  to: any;
  sdate: any;
  final: any;
  screentitle: string = "Exception-Report";
  downd = true;
  mydate = new Date();
  showsingle = true;
  showMultiple = true;
  showsingle1 = true;
  showMultiple1 = true;
  search_result_list1: any = [];
  searchlist: boolean = true;
  journeydate = false;
  invaliddate = false;
  search_details;
  isFname = false;
  isLname = false;
  tomorrow1: any;
  isOrd = false;
  isPnr = false;
  disablebtn = true;
  bookingdate = false;
  dateValid = false;
  tomorrow: any;
  arr: any = [];
  booking_ref: any = "asdasd";
  p: number = 1;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbooking: boolean = true;
  bookinglist: boolean = false;
  booking_details: any = "";
  booking_details_info: any = [];
  segment_details: any = "";
  pax_detail: any = "";
  loader: any = false;
  uid: any;
  cancelbtn: any;
  BOOKING_STATUS: any;
  cancelHistory: any = [];
  isCancelOpen: boolean = false;
  isJpNumber: boolean = false;
  noresult: any = "";
  cancellation_accrual_status: any = [
    { key: 14, value: "Success" },
    { key: 15, value: "Failed" }
  ];
  newDate: any = new Date();
  myDate: any = new Date();
  totalItems: number = 1;
  typeOfRedemption: any = "R";
  typeOfRedem: any = "R";
  cancellation_IM_redeem_status = [
    { key: 16, value: "Success" },
    { key: 17, value: "Failed" }
  ]
  IsEmptyVal: boolean = false;
  cancellation_redeem_status = [
    { key: 16, value: "Success" },
    { key: 17, value: "Failed" }

  ]
  initialPageCount: number = 1;
  constructor(private vernostService: VernostServiceService, private commonService: CommonService, private router: Router, private datePipe: DatePipe) { }

  ngOnInit() {
    this.isJpNumber = false;
    this.cancelbtn = true;
    this.isCancelOpen = false;
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.search_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      Exception_status: "",
      Exception_type: "",
      cancellation_accr_status: "",
      Cancellation_Redeemp_Status: "",
      cancellation_IM_redeemp_status: ""
    };
  }
  searchForm() {
    this.existingbooking = true;
    this.bookinglist = false;
    this.initialPageCount = 1;
    this.p = 1;
    this.searchData();
  }
  selectTypeOfRedemption(type) {
    this.typeOfRedemption = type;
  }
  ngAfterContentInit() {
    this.search_details.bookingdate_to = new Date();
    this.search_details.bookingdate_from = new Date();
    this.final = this.search_details.bookingdate_to.setDate(
      this.search_details.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
  }
  pageCount(count) {
    console.log("count----->", count);
    this.p = count;
    this.searchData();
  }

  searchData() {
    this.noresult = "";
    // && this.isPnr == false && this.isOrd == false && this.isFname == false && this.isLname == false 
    if (this.isJpNumber == false) {
      this.loader = true;
      this.searchlist = false;
      this.cancelbtn = true;
      this.search_result_list = [];
      this.search_result_list1 = [];
      this.order_Id_list = [];
      this.search_detail_list = [];
      var Todate = this.search_details.bookingdate_to;
      if (Todate != "") {
        Todate.setDate(Todate.getDate());
      }
      this.search_details.bookingdate_from = this.datePipe.transform(
        this.search_details.bookingdate_from,
        "yyyy-MM-dd"
      );
      Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");

      var boofrom = this.search_details.bookingdate_from;
      var bookto = Todate;
      var jp_number = "";
      if (this.typeOfRedemption == "R") {
        jp_number = "00" + this.search_details.jp_number;
      }else{
        jp_number = this.search_details.jp_number;
      }
      var BOOKING_REF_NO = (this.search_details.order_id.toString().length <= 15 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);
      var datarequest = {
        booking_fromdate: boofrom,
        booking_todate: bookto,
        jp_number: jp_number,
        order_id: BOOKING_REF_NO,
        initialPageCount: this.initialPageCount,
        cancellation_redeem_status: this.search_details.Cancellation_Redeemp_Status,
        cancellation_accrual_status: this.search_details.cancellation_accr_status,
        cancellation_IM_redeem_status: this.search_details.cancellation_IM_redeemp_status,
        pagination: this.p,
        typeOfRedemption: this.typeOfRedemption,
        };

      this.vernostService.getExceptionreport(datarequest).subscribe(response => {
        var Data = response;
        this.typeOfRedem = this.typeOfRedemption;
        var count = Data[0].count;
        this.initialPageCount = Data[0].count
        this.totalItems = count;
        this.search_result_list = Data[0].result;
        console.log("search_result_list------------->", JSON.stringify(this.search_result_list));

        this.search_detail_list = this.search_result_list;
        // console.log("this.totalItems------------------>", this.totalItems);
        // console.log("this.search_detail_list------------>", JSON.stringify(this.search_detail_list));
        // console.log("this.totalItems------------------>", this.totalItems);


        if (this.search_detail_list.length == 0 || this.search_detail_list == undefined || this.search_detail_list == "") {
          this.noresult = "Result Not Found";
          this.loader = false;

        } else {
          this.loader = false;
        }
      });
    }
  }

  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  book_details(param, type) {
    if (type == "book") {
      this.loader = true;
    }
    let data = {
      booking_ref: param
    };
    this.vernostService.getBookingDetails(data).subscribe(response => {
      this.loader = false;

      this.booking_details_info = response[0].booking[0];
      this.booking_details = response[0].booking;
      this.segment_details = response[0].segment_details;
      this.pax_detail = response[0].pax_detail;
      this.BOOKING_STATUS = this.booking_details.BOOKING_STATUS;
    });

    if (type == "book") {
      this.existingbooking = false;
      this.bookinglist = true;
      this.isCancelOpen = false;
    } else {
      this.isCancelOpen = true;
    }
  }

  cancelBooking(ORDER_ID, type) {
    this.cancelbtn = true;
    var arrayrequest = {
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref,
      ORDER_ID: this.booking_details_info.ORDER_ID,
      ORIGIN: this.segment_details[0].ORIGIN,
      DESTINATION: this.segment_details[0].DESTINATION,
      TRANSACTION_ID: this.booking_details_info.TRANSACTION_ID,
      TRIP_ID: this.booking_details.TRIP_ID,
      JP_NUMBER: this.booking_details_info.JP_NUMBER,
      PRODUCT_TYPE: this.booking_details_info.ORDER_TYPE,
      TIER: this.booking_details_info.TIER,
      CANCELLED_BY: this.uid,
      CREATED_BY: this.uid
    };
    this.vernostService
      .cancelHistoryFlightBooking(arrayrequest).subscribe(
        response => {
          if (response[0].status == "Success") {
            this.cancelbtn = false;
          }
          if (response[0].status == "failed") {
            this.cancelbtn = true;
          }
        });
    var updateArrayRequest = {
      BOOKING_STATUS: 11,
      TRANSACTION_STATUS: "",
      MEMBER_POINT_BALANCE: "",
      ORDER_ID: this.booking_details_info.ORDER_ID,
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref
    };
    this.vernostService.cancelFlightBooking(updateArrayRequest).subscribe(response => {
    });
  }

  //#region Validations
  jpNumberValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;
    var JPNo = this.search_details.jp_number;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("JpErr").innerHTML = "Only Alphabets and Numbers allowed";
      document.getElementById("JpErr").style.color = "red";
      this.isJpNumber = true;
    } else {
      document.getElementById("JpErr").innerHTML = "";
      this.isJpNumber = false;
    }
  }

  ticketValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;
    var JPNo = this.search_details.Ticket_No;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("TkErr").innerHTML = "Only AlphaNumeric allowed";
      document.getElementById("TkErr").style.color = "red";
      this.isJpNumber = true;
    } else {
      document.getElementById("TkErr").innerHTML = "";
      this.isJpNumber = false;
    }
  }

  jpNumberValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.jp_number;
    if (JPNo.length > 0) {
      if (JPNo.length < 9) {
        document.getElementById("JpErr").innerHTML = "Please enter the correct JP number.";
        document.getElementById("JpErr").style.color = "red";
        this.isJpNumber = true;
      } else {
        document.getElementById("JpErr").innerHTML = "";
        this.isJpNumber = false;
      }
    }
  }

  fnameValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;
    var JPNo = this.search_details.first_name;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("fnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("fnErr").style.color = "red";
      this.isFname = true;
    } else {
      document.getElementById("fnErr").innerHTML = "";
      this.isFname = false;
    }
  }

  lnameValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z]+$/;
    var JPNo = this.search_details.last_name;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("lnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("lnErr").style.color = "red";
      this.isLname = true;
    } else {
      document.getElementById("lnErr").innerHTML = "";
      this.isLname = false;
    }
  }

  orderValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;
    var JPNo = this.search_details.order_id;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("orErr").innerHTML = "Only Alphabets and Numbers allowed";
      document.getElementById("orErr").style.color = "red";
      this.isOrd = true;
    } else {
      document.getElementById("orErr").innerHTML = "";
      this.isOrd = false;
    }
  }

  orderValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.order_id;
    if (JPNo.length > 0) {
      if (JPNo.length < 14) {
        document.getElementById("orErr").innerHTML = "Please enter 18 digit Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
      }
    }
  }

  pnrValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.airlinepnr;
    if (JPNo.length > 0) {
      if (JPNo.length < 5) {
        document.getElementById("pnrNO").innerHTML = "Please enter 5 digit PNR No ";
        document.getElementById("pnrNO").style.color = "red";
        this.isPnr = true;
      } else {
        document.getElementById("pnrNO").innerHTML = "";
        this.isPnr = false;
      }
    }
  }

  pnrValidation() {
    this.disablebtn = false;
    var regex = /^[A-Za-z0-9_]+$/;
    var JPNo = this.search_details.airlinepnr;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("pnrNO").innerHTML = "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.isPnr = true;
    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.isPnr = false;
    }
  }
  //#endregion


  toggleDisable1() {
    this.bookingdate = true;
    if (
      this.search_details.tripdate_from.length != "" ||
      this.search_details.tripdate_to.length != ""
    ) {
      this.bookingdate = true;
    } else {
      this.bookingdate = false;
    }
  }

  toggleDisable2() {
    this.journeydate = true;
    this.search_details.bookingdate_to = "";
  }



  isEmpty() {
    if (
      this.search_details.jp_number == "" &&
      this.search_details.airlinepnr == "" &&
      this.search_details.order_id == "" &&
      this.search_details.Ticket_No == "" &&
      this.search_details.first_name == "" &&
      this.search_details.last_name == "" &&
      this.search_details.status == "E" &&
      (this.search_details.bookingdate_from == "" ||
        this.search_details.bookingdate_to == "")
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
  }

  checkempty() {
    if (
      this.search_details.bookingdate_from == "" ||
      this.search_details.bookingdate_to == ""
    ) {
      this.dateValid = true;
    } else {
      this.dateValid = false;
    }
    if (
      this.search_details.jp_number.length == 0 &&
      this.search_details.Ticket_No.length == 0 &&
      this.search_details.last_name.length == 0 &&
      this.search_details.first_name.length == 0 &&
      this.search_details.airlinepnr.length == 0 &&
      this.search_details.order_id.length == 0 &&
      this.search_details.status == "E"
    ) {
      this.disablebtn = true;
    }

    if (
      this.search_details.jp_number.length == 0 &&
      this.search_details.last_name.length == 0 &&
      this.search_details.first_name.length == 0 &&
      this.search_details.airlinepnr.length == 0 &&
      this.search_details.order_id.length == 0 &&
      this.search_details.Ticket_No.length == 0 &&
      this.search_details.status != "E"
    ) {
      this.isJpNumber = false;
      this.disablebtn = false;
      this.isFname = false;
      this.isLname = false;
      this.isPnr = false;
      this.isOrd = false;
      this.invaliddate = false;
      this.dateValid = false;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.Ticket_No.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from != "" &&
        this.search_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.last_name.length != 0 ||
        this.search_details.first_name.length != 0 ||
        this.search_details.Ticket_No.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.order_id.length != 0 ||
        this.search_details.status != "E") &&
      (this.search_details.bookingdate_from == "" &&
        this.search_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.search_details.bookingdate_from == "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }

  reset() {
    this.input.value = "";
    this.search_details.tripdate_from = "";
    this.tomorrow = "";
  }

  reset2() {
    this.input2.value = "";
    this.search_details.tripdate_to = "";
  }

  reset3() {
    this.input3.value = "";
    this.search_details.bookingdate_from = "";
    this.tomorrow1 = "";
    this.final = "";
    this.isEmpty();
  }

  reset4() {
    this.input4.value = "";
    this.search_details.bookingdate_to = "";
    this.isEmpty();
  }

  // downloadData(file_name) {
  //   var fname = file_name + "out.csv";
  //   this.vernostService.downloadFile(fname).subscribe(
  //     data => {
  //       saveAs(data, "Exception-FTR.csv");
  //       this.loader = false;
  //     },
  //     err => { }
  //   );
  // }

  getExceptionReport() {
    this.noresult = "";
    // this.isPnr == false && this.isOrd == false && this.isFname == false && this.isLname == false
    if ( this.isJpNumber == false ) {
      this.loader = true;
      var Todate = this.search_details.bookingdate_to;
      if (Todate != "") {
        Todate.setDate(Todate.getDate());
      }
      this.search_details.bookingdate_from = this.datePipe.transform(
        this.search_details.bookingdate_from,
        "yyyy-MM-dd"
      );
      Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");
      var boofrom = this.search_details.bookingdate_from;
      var bookto = Todate;
      //document.getElementById("rdiv").innerHTML = "hefrerf";
      // var AirLine_Pnr = this.search_details.airlinepnr;
      var jp_number = "";
      jp_number = "00" + this.search_details.jp_number;
      var cancellation_redeem_status= this.search_details.Cancellation_Redeemp_Status;
      var cancellation_accrual_status =  this.search_details.cancellation_accr_status;
      var cancellation_IM_redeem_status =  this.search_details.cancellation_IM_redeemp_status;
     
   
      var BOOKING_REF_NO = (this.search_details.order_id.toString().length <= 15 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);
      var url = "getExceptionReportDownload";
      var queryData = "?booking_fromdate=" + boofrom + "&booking_todate=" + bookto + "&jp_number=" + jp_number + "&order_id=" + BOOKING_REF_NO + "&cancellation_accrual_status=" + cancellation_accrual_status + "&cancellation_redeem_status=" + cancellation_redeem_status + "&cancellation_IM_redeem_status=" + cancellation_IM_redeem_status + "&typeOfRedemption=" + this.typeOfRedemption 
      window.open(window["omsubconfig"].backOffice + "/" + url + queryData, "_blank");
      this.loader = false;

    }
    // + "&Exception_status=" + Exception_status + "&Exception_type=" + Exception_type
  }

  checkStatus() {
    this.showsingle = true;
    this.showMultiple = true;
    if (
      this.search_details.tripdate_from == "" &&
      this.search_details.tripdate_to != ""
    ) {
      this.showMultiple = false;
      this.Gdate = this.search_details.tripdate_to;
      //document.getElementById("rdiv").innerHTML = "To Date";
    }
    if (
      this.search_details.tripdate_to == "" &&
      this.search_details.tripdate_from != ""
    ) {
      this.showMultiple = false;
      this.Gdate = this.search_details.tripdate_from;
      //document.getElementById("rdiv").innerHTML = "From Date";
    }
    if (
      this.search_details.tripdate_to != "" &&
      this.search_details.tripdate_from != ""
    ) {
      this.showsingle = false;
      this.from = this.search_details.tripdate_from;
      this.to = this.search_details.tripdate_to;
    }
  }

  increaseDate() {
    this.final = this.commonService.increaseDate();
    this.final = new Date(this.final);
  }
  checkStatus1() {
    this.mydate = this.search_details.bookingdate_from;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;
    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.downd = false;
    } else {
      this.downd = true;
    }
  }
}
